import request from '@/utils/request'
import smRequest from '@/utils/smRequest'
import $md5 from 'js-md5'
export function login(data){
  let d = Object.assign({}, data)
  d.pwd = $md5(d.pwd)
  return smRequest('/website/v1/api/user/login', d)
}

export function chkPriSts(data){
  let d = Object.assign({}, data)
  d.pwd = $md5(d.pwd)
  return smRequest('/website/v1/api/user/chkPriSts', d)
}
export function sendRegSms(data){
  return smRequest('/website/v1/api/user/sendRegSms', data)
}

export function sendLgnSms(data){
  let d = Object.assign({}, data)
  d.pwd = $md5(d.pwd)
  return smRequest('/website/v1/api/user/sendLgnSms', d)
}

export function imgCode(){
  return request({
    url: '/website/v1/api/user/imgCode',
    method: 'get'
  })
}

export function register(data){
  let d = Object.assign({}, data)
  d.pwd = $md5(d.pwd)
  return smRequest('/website/v1/api/user/register', d)
}

export function userInfo() {
  return request({
    url: '/website/v1/api/user/userInfo',
    method: 'get'
  })
}

export function checkLogin() {
  return request({
    url: '/website/v1/api/user/check',
    method: 'get'
  })
}

export function logout() {
  return request({
    url: '/website/v1/api/user/logout',
    method: 'get'
  })
}

export function resetPwd(data){
  let d = Object.assign({}, data)
  d.pwd = $md5(d.pwd)
  return smRequest('/website/v1/api/user/resetPwd', d)
}

export function loginResetPwd(data){
  let d = Object.assign({}, data)
  d.pwd = $md5(d.pwd)
  d.oldPwd = $md5(d.oldPwd)
  return smRequest('/website/v1/api/user/loginResetPwd', d)
}

export function sendFndPwdValidCode(data){
  return smRequest('/website/v1/api/user/sendFndPwdValidCode', data)
}

export function userDestroy(data){
  let d = Object.assign({}, data)
  d.pwd = $md5(d.pwd)
  return smRequest('/website/v1/api/user/destroy', d)
}

export function authPre() {
  return request({
    url: '/website/v1/api/user/authPre',
    method: 'get'
  })
}

export function sndAuthVldCod(token) {
  return request({
    url: '/website/v1/api/user/sndAuthVldCod',
    method: 'get',
    params: { token }
  })
}

export function cnlCtt() {
  return request({
    url: '/website/v1/api/user/cnlCtt',
    method: 'get'
  })
}

export function regCtn() {
  return request({
    url: '/website/v1/api/user/regCtn',
    method: 'get'
  })
}
export function mblAuth(data){
  return smRequest('/website/v1/api/user/mblAuth', data)
}

export function balAuth(data){
  return smRequest('/website/v1/api/user/balAuth', data)
}

export function mblHolderAuth(data){
  return smRequest('/website/v1/api/user/mblHolderAuth', data)
}

